/*
 * zoom-modal.js
 * Adauga zoom (rotita, dublu-clic, drag-pan) + bara cu butoane +/- in
 * fereastra fullscreen a produsului (product-media-modal, tema Dawn).
 * Fara dependinte externe.
 */
(function () {
  'use strict';

  var MIN = 1;
  var MAX = 4;
  var STEP = 0.5;

  function setup(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog') || modal;
    if (!content || modal.dataset.zoomReady === '1') return;
    modal.dataset.zoomReady = '1';

    var state = new WeakMap(); // img -> { scale, x, y }
    var active = null;

    function st(img) {
      var s = state.get(img);
      if (!s) {
        s = { scale: 1, x: 0, y: 0 };
        state.set(img, s);
      }
      return s;
    }

    function clamp(img) {
      var s = st(img);
      var maxX = (img.clientWidth * (s.scale - 1)) / 2;
      var maxY = (img.clientHeight * (s.scale - 1)) / 2;
      s.x = Math.max(-maxX, Math.min(maxX, s.x));
      s.y = Math.max(-maxY, Math.min(maxY, s.y));
    }

    function paint(img) {
      var s = st(img);
      img.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px) scale(' + s.scale + ')';
      img.classList.toggle('is-zoomed', s.scale > 1);
    }

    function apply(img) {
      paint(img);
      updateLabel();
    }

    function reset(img) {
      var s = st(img);
      s.scale = 1;
      s.x = 0;
      s.y = 0;
      apply(img);
    }

    function zoomBy(img, delta, ox, oy) {
      var s = st(img);
      var old = s.scale;
      var next = Math.min(MAX, Math.max(MIN, Math.round((old + delta) * 100) / 100));
      if (next === old) return;
      if (ox != null) {
        var ratio = next / old;
        s.x = ox - (ox - s.x) * ratio;
        s.y = oy - (oy - s.y) * ratio;
      }
      s.scale = next;
      if (next === 1) {
        s.x = 0;
        s.y = 0;
      }
      clamp(img);
      apply(img);
    }

    function imgs() {
      return Array.prototype.slice.call(content.querySelectorAll('img'));
    }

    function curImg() {
      return active || imgs()[0] || null;
    }

    function setActive(img) {
      active = img;
      updateLabel();
    }

    imgs().forEach(function (img) {
      img.addEventListener('pointerenter', function () {
        setActive(img);
      });

      img.addEventListener('wheel', function (e) {
        e.preventDefault();
        setActive(img);
        var rect = img.getBoundingClientRect();
        var cx = e.clientX - (rect.left + rect.width / 2);
        var cy = e.clientY - (rect.top + rect.height / 2);
        zoomBy(img, e.deltaY < 0 ? STEP : -STEP, cx, cy);
      }, { passive: false });

      img.addEventListener('dblclick', function (e) {
        setActive(img);
        if (st(img).scale > 1) {
          reset(img);
        } else {
          var rect = img.getBoundingClientRect();
          var cx = e.clientX - (rect.left + rect.width / 2);
          var cy = e.clientY - (rect.top + rect.height / 2);
          zoomBy(img, MAX - 1, cx, cy);
        }
      });

      // Drag pan (doar cand e marit)
      var dragging = false;
      var sx = 0, sy = 0, ox = 0, oy = 0;

      img.addEventListener('pointerdown', function (e) {
        setActive(img);
        if (st(img).scale <= 1) return;
        dragging = true;
        sx = e.clientX;
        sy = e.clientY;
        ox = st(img).x;
        oy = st(img).y;
        img.classList.add('is-grabbing');
        try { img.setPointerCapture(e.pointerId); } catch (err) {}
      });

      img.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var s = st(img);
        s.x = ox + (e.clientX - sx);
        s.y = oy + (e.clientY - sy);
        clamp(img);
        paint(img);
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        img.classList.remove('is-grabbing');
        try { img.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      img.addEventListener('pointerup', endDrag);
      img.addEventListener('pointercancel', endDrag);
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    // Bara de control
    var bar = document.createElement('div');
    bar.className = 'zoom-controls';
    bar.innerHTML =
      '<button type="button" class="zoom-controls__btn" data-zoom="out" aria-label="Micsoreaza">−</button>' +
      '<span class="zoom-controls__label" aria-live="polite">100%</span>' +
      '<button type="button" class="zoom-controls__btn" data-zoom="in" aria-label="Mareste">+</button>' +
      '<button type="button" class="zoom-controls__btn zoom-controls__btn--reset" data-zoom="reset" aria-label="Reseteaza zoom">↺</button>';
    dialog.appendChild(bar);

    function updateLabel() {
      var img = curImg();
      var pct = img ? Math.round(st(img).scale * 100) : 100;
      var lbl = bar.querySelector('.zoom-controls__label');
      if (lbl) lbl.textContent = pct + '%';
    }

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zoom]');
      if (!btn) return;
      var img = curImg();
      if (!img) return;
      var action = btn.getAttribute('data-zoom');
      if (action === 'in') zoomBy(img, STEP, 0, 0);
      else if (action === 'out') zoomBy(img, -STEP, 0, 0);
      else reset(img);
    });

    // La inchidere reseteaza; la deschidere fixeaza poza pe care s-a dat clic
    var mo = new MutationObserver(function () {
      if (!modal.hasAttribute('open')) {
        imgs().forEach(reset);
        active = null;
        updateLabel();
      } else if (modal.openedBy && typeof modal.openedBy.getAttribute === 'function') {
        var id = modal.openedBy.getAttribute('data-media-id');
        var target = id && content.querySelector('img[data-media-id="' + id + '"]');
        if (target) setActive(target);
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['open'] });

    updateLabel();
  }

  function init() {
    document.querySelectorAll('product-modal.product-media-modal').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
